import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Fetch ledger transactions with filters
export const getLedgerTransactions = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Finance/ledger-transactions`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ledger transactions:", error);
    throw error;
  }
};

// Post a transaction to ledger
export const postLedgerTransaction = async (transactionId, sourceTable, accountSubHeadID = null) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Finance/post-transaction`,
      { transactionId, sourceTable, accountSubHeadID },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error posting ledger transaction:", error);
    throw error;
  }
};
